import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import PropTypes from 'prop-types';

import { VertDrawer, VertIcon } from '@vertem-core/vertice-ds';

const SearchSidebar = ({
  searchSidebarVisible, toggleSearchSidebar, children, drawerClassName,
}) => {
  const [visibleFilter, setVisibleFilter] = useState(false);

  const openFilterHandler = () => {
    setVisibleFilter(!visibleFilter);
    toggleSearchSidebar(!visibleFilter); // Inverte o valor para mostrar/ocultar
  };

  return (
    <>
      <VertDrawer
        open={searchSidebarVisible}
        rootClassName={`vert-drawer-search-sidebar ${drawerClassName}`}
        closeIcon={<VertIcon color="detached" isVertice iconName="ArrowBigLeft" />}
        onClose={() => openFilterHandler()}
      >
        { children }
      </VertDrawer>
      <MediaQuery minWidth={769}>
        { children }
      </MediaQuery>
    </>
  );
};

SearchSidebar.propTypes = {
  searchSidebarVisible: PropTypes.bool,
  toggleSearchSidebar: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  drawerClassName: PropTypes.string,
};

export default SearchSidebar;
